import React, { useState } from 'react';
import SelectableItem from './SelectableItem';

const SelectableList = ({ arrayItems, handleClick }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemClick = (item) => {
    setSelectedItem(item);
    handleClick(item);
  };

  return (
    <ul>
      {arrayItems.map((item) => (
        <SelectableItem
          key={item.id}
          item={item}
          onClick={handleItemClick}
          isSelected={item === selectedItem}
        />
      ))}
    </ul>
  );
};

export default SelectableList;
